"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadProjectSettingsByProjectPathV2 = loadProjectSettingsByProjectPathV2;
exports.shouldIgnored = shouldIgnored;
exports.getProjectSettingsPath = getProjectSettingsPath;
exports.getProjectSettingPathV2 = getProjectSettingPathV2;
const tslib_1 = require("tslib");
const fs = tslib_1.__importStar(require("fs-extra"));
const path = tslib_1.__importStar(require("path"));
const uuid = tslib_1.__importStar(require("uuid"));
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const featureFlags_1 = require("../../common/featureFlags");
const globalVars_1 = require("../../common/globalVars");
const projectSettingsHelper_1 = require("../../common/projectSettingsHelper");
const telemetry_1 = require("../../common/telemetry");
const versionMetadata_1 = require("../../common/versionMetadata");
const migrate_1 = require("../../component/migrate");
const pathUtils_1 = require("../../component/utils/pathUtils");
// export this for V2 -> V3 migration purpose
async function loadProjectSettingsByProjectPathV2(projectPath) {
    const settingsFile = getProjectSettingPathV2(projectPath);
    const projectSettings = await fs.readJson(settingsFile);
    if (!projectSettings.projectId) {
        projectSettings.projectId = uuid.v4();
        (0, telemetry_1.sendTelemetryEvent)(telemetry_1.Component.core, telemetry_1.TelemetryEvent.FillProjectId, {
            [telemetry_1.TelemetryProperty.ProjectId]: projectSettings.projectId,
        });
    }
    globalVars_1.globalVars.isVS = (0, projectSettingsHelper_1.isVSProject)(projectSettings);
    return (0, teamsfx_api_1.ok)((0, migrate_1.convertProjectSettingsV2ToV3)(projectSettings, projectPath));
}
function shouldIgnored(ctx) {
    const inputs = ctx.arguments[ctx.arguments.length - 1];
    const method = ctx.method;
    let isCreate = false;
    if (method === "getQuestions") {
        const task = ctx.arguments[0];
        isCreate = task === teamsfx_api_1.Stage.create;
    }
    return teamsfx_api_1.StaticPlatforms.includes(inputs.platform) || isCreate || inputs.ignoreLockByUT;
}
function getProjectSettingsPath(projectPath) {
    if (featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.GenerateConfigFiles)) {
        return pathUtils_1.pathUtils.getAvailableYmlFilePath(projectPath) || "";
    }
    else {
        return pathUtils_1.pathUtils.getYmlFilePath(projectPath, "dev", true) || "";
    }
}
function getProjectSettingPathV2(projectPath) {
    return path.resolve(projectPath, versionMetadata_1.MetadataV2.configFolder, "configs", versionMetadata_1.MetadataV2.configFile);
}
//# sourceMappingURL=projectSettingsLoader.js.map